const MOBILE_MQ = window.matchMedia('(max-width: 749px)');

/** @type {WeakMap<Element, Comment>} */
const anchors = new WeakMap();

/**
 * @param {Element} buttonHost
 * @returns {HTMLAnchorElement | null}
 */
function getCtaButton(buttonHost) {
  return buttonHost.querySelector('.group-block-content > .button') ?? buttonHost.querySelector('.button');
}

/**
 * @param {Element} buttonHost
 */
function wrapMobileCtaButton(buttonHost) {
  unwrapDesktopCtaButton(buttonHost);

  const button = getCtaButton(buttonHost);
  if (!button || button.parentElement?.classList.contains('image-compare-mobile-cta__shell')) return;

  const shell = document.createElement('div');
  shell.className = 'image-compare-mobile-cta__shell';
  button.parentElement?.insertBefore(shell, button);
  shell.appendChild(button);
}

/**
 * @param {Element} buttonHost
 */
function unwrapMobileCtaButton(buttonHost) {
  const shell = buttonHost.querySelector('.image-compare-mobile-cta__shell');
  const button = shell?.querySelector('.button');
  if (!shell || !button) return;

  shell.parentElement?.insertBefore(button, shell);
  shell.remove();
}

/**
 * @param {Element} buttonHost
 */
function wrapDesktopCtaButton(buttonHost) {
  unwrapMobileCtaButton(buttonHost);

  const button = getCtaButton(buttonHost);
  if (!button || button.parentElement?.classList.contains('image-compare-desktop-cta__shell')) return;

  const shell = document.createElement('div');
  shell.className = 'image-compare-desktop-cta__shell';
  button.parentElement?.insertBefore(shell, button);
  shell.appendChild(button);
}

/**
 * @param {Element} buttonHost
 */
function unwrapDesktopCtaButton(buttonHost) {
  const shell = buttonHost.querySelector('.image-compare-desktop-cta__shell');
  const button = shell?.querySelector('.button');
  if (!shell || !button) return;

  shell.parentElement?.insertBefore(button, shell);
  shell.remove();
}

/**
 * @param {Element} section
 * @returns {{ slider: Element | null, buttonAnchor: Element | null, buttonHost: Element | null }}
 */
function getImageCompareParts(section) {
  const slider = section.querySelector('comparison-slider-component');
  const contentHost = section.querySelector(':scope > .shopify-block:first-child, :scope > .group-block:first-child');
  const contentGroup = contentHost?.classList.contains('group-block')
    ? contentHost
    : contentHost?.querySelector('.group-block');
  const buttonAnchor = contentGroup?.querySelector(':scope > .group-block-content') ?? null;

  let buttonHost =
    section.querySelector('[data-image-compare-placement="mobile"]') ??
    (buttonAnchor
      ? [...buttonAnchor.children].findLast((child) => child.querySelector('.button')) ?? null
      : null);

  if (!buttonHost && slider?.nextElementSibling?.querySelector('.button')) {
    buttonHost = slider.nextElementSibling;
  }

  return { slider, buttonAnchor, buttonHost };
}

/**
 * @param {Element} section
 * @param {Element} buttonHost
 * @param {Element} buttonAnchor
 */
function restoreDesktopCta(section, buttonHost, buttonAnchor) {
  unwrapMobileCtaButton(buttonHost);
  buttonHost.classList.remove('image-compare-mobile-cta');
  delete buttonHost.dataset.imageComparePlacement;

  const placeholder = anchors.get(section);

  if (placeholder?.parentNode) {
    placeholder.parentNode.insertBefore(buttonHost, placeholder);
    placeholder.remove();
  } else if (buttonAnchor && !buttonAnchor.contains(buttonHost)) {
    buttonAnchor.appendChild(buttonHost);
  }

  anchors.delete(section);
}

/**
 * @param {Element} section
 */
function syncImageCompareCta(section) {
  const { slider, buttonAnchor, buttonHost } = getImageCompareParts(section);

  if (!slider || !buttonHost || !buttonAnchor) return;

  const isMobile = MOBILE_MQ.matches;
  const isInOriginalSlot = buttonAnchor.contains(buttonHost);

  if (!isMobile) {
    if (!isInOriginalSlot || buttonHost.dataset.imageComparePlacement === 'mobile') {
      restoreDesktopCta(section, buttonHost, buttonAnchor);
    }

    unwrapMobileCtaButton(buttonHost);
    wrapDesktopCtaButton(buttonHost);
    return;
  }

  unwrapDesktopCtaButton(buttonHost);

  if (isInOriginalSlot) {
    const placeholder = document.createComment('image-compare-cta');
    buttonAnchor.insertBefore(placeholder, buttonHost);
    anchors.set(section, placeholder);
    buttonHost.classList.add('image-compare-mobile-cta');
    slider.insertAdjacentElement('afterend', buttonHost);
    buttonHost.dataset.imageComparePlacement = 'mobile';
  } else {
    buttonHost.classList.add('image-compare-mobile-cta');
    buttonHost.dataset.imageComparePlacement = 'mobile';
  }

  wrapMobileCtaButton(buttonHost);
}

function initImageCompareMobileCta() {
  document.querySelectorAll('.section-content-wrapper:has(comparison-slider-component)').forEach((section) => {
    syncImageCompareCta(section);
  });
}

if (!window.__imageCompareMobileCtaBound) {
  window.__imageCompareMobileCtaBound = true;
  MOBILE_MQ.addEventListener('change', initImageCompareMobileCta);
  document.addEventListener('shopify:section:load', initImageCompareMobileCta);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initImageCompareMobileCta);
} else {
  initImageCompareMobileCta();
}
